import type { FC } from "react";
import { IconAttach } from "@web-monorepo/dds-icons";
import type { FileWithThumbnail } from "../types";
import XButton from "../XButton";
import { useStore } from "../state";
import FileSize from "./FileSize";
import styles from "./FilePreview.module.css";

type Props = {
  file: FileWithThumbnail | undefined;
};

const FilePreview: FC<Props> = ({ file }) => {
  const store = useStore();
  if (!file) return null;
  const fileLabel = file.displayName || file.name;

  return (
    <article className={styles.container}>
      <div className={styles.thumbnail}>
        {file.thumbnailPath ? (
          <img src={file.thumbnailPath} alt="" className={styles.thumbnailImage} />
        ) : (
          <IconAttach />
        )}
      </div>
      <div className={styles.metadata}>
        <h2 className={styles.label}>{fileLabel}</h2>
        <FileSize>{file.size}</FileSize>
      </div>
      <XButton className={styles.xButton} onClick={() => store.deleteFile(file)} />
    </article>
  );
};

export default FilePreview;
